import React from "react";
import ReactDOM from "react-dom/client";
import "./components/css/index.css";

//Public Pages
import HomePage from "./pages/public/HomePage";
import Reactions from "./pages/public/Reactions";
import ReactionDetail from "./pages/public/ReactionDetail";
import Synthons from "./pages/public/Synthons";
import SynthonDetail from "./pages/public/SynthonDetail";
import Tutorial from "./pages/public/Tutorial";
import ErrorPage from "./components/ErrorPage";
import Downloads from "./pages/public/Downloads"

// Users pages
import UserMyReactions from "./pages/user/UserMyReactions";
import ApprovedReactions from "./pages/user/ApprovedReactions";
import RegisterReactionForm from "./pages/user/RegisterReaction";

//Authentication
import LoginForm from "./pages/authentication/Login";
import RegisterForm from "./pages/authentication/Register";
import ForgotPassword from "./pages/authentication/ForgotPass";
import VerifyEmail from "./pages/authentication/VerifyEmail";
import ResetPassword from "./pages/authentication/ResetPass";

// Admin manage pages
import RxnRegistrations from "./pages/admin/ManageRxnRegistration";
import AdminLandingPage from "./pages/admin/AdminLandingPage";
import ManageReactions from "./pages/admin/ManageReactions";
import ManageTags from "./pages/admin/ManageTags";
import ManageRoles from "./pages/admin/ManageRoles";
import ManageUsers from "./pages/admin/ManageUsers";
import ManageSmarts from "./pages/admin/ManageSmarts";
import ManageSynthons from "./pages/admin/ManageSynthons";



import "bootstrap/dist/css/bootstrap.min.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AB3 from "./pages/public/AB3";
import Bioisosteres from "./pages/public/Bioisosteres";
import BioisosteresBrowser from "./pages/public/BioisosteresBrowser";
// axios.defaults.baseURL = "http://localhost:5010" ; // doesn't work inside docker container

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/register_reaction",
    element: <RegisterReactionForm />,
  },
  {
    path: "/reactions",
    element: <Reactions />,
  },
  {
    path: "/login",
    element: <LoginForm />,
  },
  {
    path: "/register",
    element: <RegisterForm />,
  },
  {
    path: "/verifyEmail/:token",
    element: <VerifyEmail />,
  },
  {
    path: "/forgotPassword",
    element: <ForgotPassword />,
  },
  {
    path: "/resetPassword/:token",
    element: <ResetPassword />,
  },
  {
    path: "/reactions/:id",
    element: <ReactionDetail />,
  },
  {
    path: "/synthons",
    element: <Synthons />,
  },
  {
    path: "/synthons/:id",
    element: <SynthonDetail />,
  },
  {
    path: "/admin",
    element: <AdminLandingPage />,
  },
  {
    path: "/admin/manage/reactions",
    element: <ManageReactions />,
  },
  {
    path: "/admin/manage/rxnRegistrations",
    element: <RxnRegistrations />,
  },
  {
    path: "/admin/manage/tags",
    element: <ManageTags />,
  },
  {
    path: "/admin/manage/roles",
    element: <ManageRoles />,
  },
  {
    path: "/admin/manage/users",
    element: <ManageUsers />,
  },
  {
    path: "/admin/manage/smarts",
    element: <ManageSmarts />,
  },
  {
    path: "/admin/manage/synthons",
    element: <ManageSynthons />,
  },
  {
    path: "/tutorials",
    element: <Tutorial />,
  },
  {
    path: "/user/myReactions",
    element: <UserMyReactions/>
  },
  {
    path: "/user/approvedReactions",
    element: <ApprovedReactions/>
  },
  {
    path: "/downloads",
    element: <Downloads/>
  },
  {
    path: "*",
    element: <ErrorPage />,
  },

  //path /ab3 or /ab3/task_id
  {
    path: "/ab3",

    element: <AB3 />,
  },
  {
    path: "/ab3/:taskId",
    element: <AB3 />,
  },
  {
    path: "/bioisosteres/transform",
    element: <Bioisosteres />,
  },
  {
    path: "/bioisosteres/browse",
    element: <BioisosteresBrowser />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <div>
    <RouterProvider router={router} />
  </div>
);
